import {
    toggleAttributeValue,
    removeAttributeValue,
    addAttributeValue,
    hasAttributeValue,
    minWidth
} from 'groots/utilities';


(function (global) { // eslint-disable-line
    var pluginName = 'GrNavigation';

    //  Constructor
    // --------------------------------------------------------------------------

    function GrNavigation(selector) {

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.triggers = this.selector.querySelectorAll('[js-nav-trigger]');
        this.overlay = document.querySelector('[gr-overlay]');
        this.subNavs = this.selector.querySelectorAll('.header__primary-nav .hs-item-has-children');
        this.mobilePanel = document.querySelector('.header-mobile__panels');
        this.mobilePanels = document.querySelectorAll('.header-mobile__panel');
        this.main = document.querySelector('.main');
        this.body = document.querySelector('body');
        this.initialScrollTop = this.getScrollTop();
        this.init();
    }

    //  Methods
    // --------------------------------------------------------------------------
    GrNavigation.prototype.init = function init() {
        this.bindings();
        this.constructNav();
        this.mouse();

        // var width = document.querySelector('.header__primary-nav').offsetWidth;
        // document.querySelector('[js-subnav~="ready"] .hs-menu-children-wrapper').style.width = width + 'px';

        var scrollTop = this.getScrollTop();
        if (minWidth()) {
            if (scrollTop > 100 && minWidth()) {
                addAttributeValue(this.selector, 'js-header', 'is-sticky');
            }
        }
    };

    GrNavigation.prototype.bindings = function bindings() {
        var instance = this;

        for (var i = 0, max = this.triggers.length; i < max; i++) {
            this.triggers[i].addEventListener('click', function(e) {
                e.preventDefault();
                toggleAttributeValue(instance.selector, 'js-header', 'is-opened');
                toggleAttributeValue(instance.main, 'js-header-state', 'is-opened');
                toggleAttributeValue(instance.overlay, 'gr-overlay', 'visible');
            });
        }


        this.overlay.addEventListener('click', function() {
            toggleAttributeValue(instance.selector, 'js-header', 'is-opened');
            toggleAttributeValue(instance.main, 'js-header-state', 'is-opened');
            instance.overlay.setAttribute('gr-overlay', '');
        });

        var ticking = false;

        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    var scrollTop = instance.getScrollTop();
                    var delta = scrollTop - instance.initialScrollTop;
                    var state = hasAttributeValue(instance.selector, 'js-header', 'is-sticky');

                    if (minWidth()) {
                        if (scrollTop > 20 && delta > 0 && !state) {
                            addAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        } else if (scrollTop < 20 && state) {
                            removeAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        }

                        instance.initialScrollTop = scrollTop;
                    } else {
                        if (scrollTop > 1 && !state) {
                            addAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        } else if (scrollTop <= 1 && state) {
                            removeAttributeValue(instance.selector, 'js-header', 'is-sticky');
                        }
                    }

                    ticking = false;
                });

                ticking = true;
            }
        });



        // var tickingResize = false;
        // window.addEventListener('resize', function() {
        //     if (!tickingResize) {
        //         window.requestAnimationFrame(function() {
        //             var width = document.querySelector('.header__primary-nav').offsetWidth;
        //             document.querySelector('[js-subnav~="ready"] .hs-menu-children-wrapper').style.width = width + 'px';

        //             tickingResize = false;
        //         });

        //         tickingResize = true;
        //     }
        // });


    };

    GrNavigation.prototype.constructNav = function constructNav() {
        if (this.main) {
            this.main.setAttribute('js-header-state', '');
        }

        for (var i = 0, max = this.subNavs.length; i < max; i++) {

            var module = this.subNavs[i].querySelector('.hs-menu-children-wrapper a').getAttribute('href');
            this.subNavs[i].setAttribute('js-subNav-ready','');

            if (module.indexOf('#module-subnav-') !== -1) {
                var moduleId = module.replace('#module-subnav-', '');
                var subNav = document.querySelector('.module-subnav-' + moduleId);

                if (subNav) {
                    var cln = subNav.cloneNode(true);

                    this.subNavs[i].querySelector('.hs-menu-children-wrapper').innerHTML = '';
                    this.subNavs[i].querySelector('.hs-menu-children-wrapper').appendChild(cln);
                    this.subNavs[i].setAttribute('js-subNav','ready');
                }
            }

        }
    };

    GrNavigation.prototype.mouse = function mouse() {
        var instance = this;
        var dropdownMenuTimer;

        for (var i = 0, max = this.subNavs.length; i < max; i++) {

            this.subNavs[i].addEventListener('mouseenter', function(e) {
                e.preventDefault();

                // var elementW = this.clientWidth;
                // var subnavW = this.querySelector('.subnav').clientWidth;

                // this.querySelector('.subnav').style.transform = 'translateX(calc(50% - ' + (subnavW - elementW)+ 'px)';

                for (var x = 0, max = instance.subNavs.length; x < max; x++) {
                    removeAttributeValue(instance.subNavs[x], 'js-subnav', 'is-active');
                }

                addAttributeValue(this, 'js-subnav', 'is-active');
                clearTimeout(dropdownMenuTimer);
            });

            this.subNavs[i].addEventListener('mouseleave', function(e) {
                e.preventDefault();
                var that = this;

                dropdownMenuTimer = setTimeout(function () {
                    removeAttributeValue(that, 'js-subnav', 'is-active');
                }, 400);
            });
        }
    };


    GrNavigation.prototype.getScrollTop = function getScrollTop(){
        if (typeof pageYOffset !== 'undefined'){
            //most browsers except IE before #9
            return pageYOffset;
        } else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = (D.clientHeight) ? D : B;
            return D.scrollTop;
        }
    };

    // Auto-Instantiation
    // --------------------------------------------------------------------------
    document.addEventListener('DOMContentLoaded', function() {
        var all = {}, index;
        if (document.querySelectorAll('[js-header]').length) {
            window.groots.grNavigation = { instances: {} };
            all = document.querySelectorAll('[js-header]');
            index = -1;
            while (all[++index]) {
                global.grNavigation.instances[index] = new GrNavigation(all[index]);
            }
        }
    });

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = GrNavigation;
    // Export to Browser
    else global[pluginName] = GrNavigation; // eslint-disable-line

}(window.groots));

